//noinspection JSUnusedGlobalSymbols
export default {

    all: state => Object.values(state.entities),

    counts: state => state.counts,

    allByIsAgencyOfCompanyId: ( state, getters ) => companyId  => {
        return getters['all'].filter(company => company.companies.includes(companyId))
    },

    allByIsPurchaser: ( state, getters )  => {
        return getters['all'].filter(company => company.isPurchaser)
    },

    allByIsSupplier: ( state, getters )  => {
        return getters['all'].filter(company => company.isSupplier)
    },

    byId: state => id => {
        return state.entities[id]
    },

    draft: state =>  {
        return state.draft
    },

    isZmuek: state => {
        return state.entities[2]
    },

}


